// src/utils/geocodeAddress.js
import { auth } from "../firebase";

const GEOCODE_ADDRESS_URL =
  import.meta.env.VITE_GEOCODE_ADDRESS_URL ||
  "https://us-central1-manidinebackend.cloudfunctions.net/geocodeAddressHttp";

// Geocode a full address string and return { lat, lng } or null on failure
export async function geocodeAddress(address) {
  try {
    if (!address) {
      console.warn("[geocodeAddress] No address supplied");
      return null;
    }

    const user = auth.currentUser;
    if (!user) {
      console.warn("[geocodeAddress] No signed-in user available for backend geocoding");
      return null;
    }

    const idToken = await user.getIdToken(true);

    const res = await fetch(GEOCODE_ADDRESS_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${idToken}`,
      },
      body: JSON.stringify({ address }),
    });

    const data = await res.json().catch(() => null);
    console.log("[geocodeAddress] Backend response:", data);

    if (!res.ok || !data?.ok) {
      console.warn(
        "[geocodeAddress] Failed status:",
        res.status,
        data?.error || "Unknown geocode error"
      );
      return null;
    }

    const lat = typeof data?.lat === "number" ? data.lat : Number(data?.lat);
    const lng = typeof data?.lng === "number" ? data.lng : Number(data?.lng);

    if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
      console.warn("[geocodeAddress] Invalid lat/lng:", data?.lat, data?.lng);
      return null;
    }

    return { lat, lng, formattedAddress: data?.formattedAddress || null };
  } catch (err) {
    console.error("[geocodeAddress] Unexpected error:", err);
    return null;
  }
}